import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import type { ReactNode } from 'react';
import React from 'react';
import Footer from 'v2/components/Shared/Footer';

import Header from './Header';

const styles = makeStyles((theme) => ({
  content: {
    minHeight: '100%',
    position: 'relative',
    zIndex: 3,
  },
  container: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    padding: '2rem 2rem 1rem 2rem',
    maxWidth: '1440px',
    minHeight: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem',
    },
  },
}));

interface IProps {
  children: ReactNode;
}

const UnloggedLayout = ({ children }: IProps) => {
  const classes = styles();

  return (
    <>
      <CssBaseline />
      <div className='eduzz-ui-layout-topbar'>
        <Header />
      </div>
      <div className={classes.content}>
        <div className={classes.container}>{children}</div>
      </div>
      <Footer hideQuickHelp />
    </>
  );
};
export default UnloggedLayout;
